import { render } from "./AllPosts.vue?vue&type=template&id=1f245547&scoped=true"
import script from "./AllPosts.vue?vue&type=script&lang=js"
export * from "./AllPosts.vue?vue&type=script&lang=js"

import "./AllPosts.vue?vue&type=style&index=0&id=1f245547&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Nebula PC\\Coding\\web-projects\\snowchron\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f245547"]])

export default __exports__